import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../../jss_setup";
import TravellerForm from "./TravellerForm";

const travellersFormsStyles = createUseStyles({
  forms: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    overflow: "auto",
    height: "max-content",
    maxHeight: "70vh",
    gridAutoFlow: "row",
    gridAutoRows: "max-content",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.forms", {}),
  }),
  form: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.form", {}),
  }),
  guestHeader: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.guestHeader", {}),
  }),
  divider: (props) => ({
    height: `calc(${jssVariables.normal_gap} / 4)`,
    width: "100%",
    background: jssVariables.colors.base_color,
    margin: `calc(${jssVariables.normal_gap} * 1) 0`,
    ..._.get(props, "customStyles.divider", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    forms: (props) => ({
      gridAutoFlow: "unset",
      gridTemplateColumns: props.pax === 1 ? "1fr" : "repeat(2, 1fr)",

      maxHeight: "70vh",
      ..._.get(props, "customStyles.forms.smallscreen", {}),
    }),
    form: (props) => ({
      display: "grid",
      gridGap: jssVariables.normal_gap,
      gridTemplateColumns: props.pax > 1 ? "1fr 1fr" : "1fr",
      ..._.get(props, "customStyles.form.smallscreen", {}),
    }),
    divider: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.divider.smallscreen", {}),
    }),
  },
});
const TravellersForms = ({ forms, optsForDisplay, guests, setGuests }) => {
  const pax = _.get(guests, "length", 0);

  const classes = travellersFormsStyles({
    pax,
  });

  return (
    <div className={classes.forms}>
      {guests.map((guest, idx) => (
        <TravellerForm
          key={idx}
          idx={idx + 1}
          formStructure={{
            ...forms.find((f) => f.guest_uuid === guest.guest_uuid),
            product_name: _.get(
              optsForDisplay.items.find(
                (item) => item.product_id === guest.product_id
              ),
              "name",
              ""
            ),
          }}
          guest={guest}
          setGuests={setGuests}
        />
      ))}
    </div>
  );
};
TravellersForms.defaultProps = {
  forms: [],
  selections: {},
  guests: [],
};
TravellersForms.propTypes = {
  forms: PropTypes.array.isRequired,
  selections: PropTypes.object.isRequired,
  guests: PropTypes.array.isRequired,
  setGuests: PropTypes.func.isRequired,
};

export default TravellersForms;
